import * as z from "zod";

export const duplicateCampaign = {
  name: "duplicateCampaign" as const,
  input: z.object({ id: z.string(), name: z.string() }),
  output: z.null(),
};
